import styled from 'styled-components'

export const Content = styled.div`
	padding: 12px 12px 0;
`
